// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"485":"fece09f6","776":"af12c947"}[chunkId] + ".chunk.js";
};